// extracted by mini-css-extract-plugin
export default {"base":"vp_X5H_O","exclamation":"vp_w75IK","fill":"vp_aMdt4","scale":"vp_bLIIQ","circle":"vp_SGPDb","stroke":"vp_Eludc","exclamationLine":"vp_r8s3C","exclamationDot":"vp_HEJ6C"};